import React, {useState} from "react";
import SlotItem from "./slotItem.component";
import {Button, Card, Col, Modal, Row} from "react-bootstrap";
import {
    electricOutletToText, GENRES,
    intersperse,
    isLoggedIn, isLoggedInWithRole,
    isLoggedInWithRoleAndUserIs,
    sizeToText,
    soundSystemToText
} from "../../common/utils";
import VenuesService from "../../services/venues.service";
import Container from "react-bootstrap/Container";
import AuthService from "../../services/auth.service";
import {API_EDITS_ALLOWED} from "../../services/axios.utils";

const VenueItem = ({venue}) => {
    let canEdit = isLoggedInWithRoleAndUserIs('host', venue.creator_id);
    let loggedInAdmin = isLoggedInWithRole('admin');

    let user = AuthService.getCurrentUser();
    let loggedIn = isLoggedIn();
    let editsAllowed = API_EDITS_ALLOWED === "true" || (loggedIn && user.is_admin);

    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const handleCloseDeleteModal = () => setShowDeleteModal(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);

    const deleteVenue = () => {
        VenuesService.deleteVenue(venue.id).then(
            response => {
                console.log("venue:" + venue.id + " deleted");
                // todo: pass redirect url since could be coming from "/myvenues"
                window.location.assign("/venues");
            },
            error => {
                console.log(error);
            });
    }

    let translated_act_types = []
    for (let i = 0; i < venue.preferred_act_types.length; i++) {
        translated_act_types.push(GENRES.find(genre => genre.value === venue.preferred_act_types[i])?.name);
    }
    let act_types = translated_act_types.map(function (x, i) {
        return <span key={i} style={{textTransform: 'capitalize'}}>{x}</span>;
    });
    const display_act_types = intersperse(act_types, ", ");

    let displaySlots = venue.available_slots.map(function (x, i) {
        return <span key={i}><SlotItem key={i} slot={x}/><br/></span>
    });


    return (
        <>
            <Card>
                <Card.Body>
                    <Card.Title>
                        <span>&#127968;</span>&nbsp;
                        <span className="fs-4 text"><strong>{venue.address}</strong></span>
                        {canEdit &&
                            <>
                                &nbsp;&nbsp;
                                <span>
                                    <Button size="sm" variant="outline-primary" href={`/venues/${venue.id}/edit`} disabled={!editsAllowed}>
                                        Edit
                                    </Button>&nbsp;&nbsp;
                                    <Button size="sm" variant="outline-success" href={`/venues/${venue.id}/slots/edit`} disabled={!editsAllowed}>
                                        Slots / Schedule
                                    </Button>&nbsp;&nbsp;
                                    <Button size="sm" variant="outline-danger" onClick={handleShowDeleteModal} disabled={!editsAllowed}>
                                        Delete
                                    </Button>
                                </span>
                            </>
                        }
                        {loggedIn &&
                            <>
                                &nbsp;&nbsp;
                                <Button size="sm" variant="outline-info" href={`/venues/${venue.id}/contact`} disabled={!editsAllowed}>
                                    Contact
                                </Button>
                            </>
                        }
                    </Card.Title>

                    <Container fluid>
                        {loggedInAdmin &&
                            <>
                                <Row><Col><strong>Creator</strong></Col></Row>
                                <Row className="mb-3">
                                    <Col>
                                        {venue.creator.name} / {venue.creator.email} / {intersperse(venue.creator.roles, ", ")}
                                    </Col>
                                </Row>
                            </>
                        }

                        <Row><Col><strong>Description</strong></Col></Row>
                        <Row className="mb-3">
                            <Col>
                                <span dangerouslySetInnerHTML={{__html: venue.bio}} className="pf-quill-render"></span>
                            </Col>
                        </Row>

                        <Row><Col><strong>Preferred size</strong></Col></Row>
                        <Row className="mb-3">
                            <Col>
                                <span dangerouslySetInnerHTML={{__html: sizeToText(venue.size_pref)}}/>
                            </Col>
                        </Row>

                        <Row><Col><strong>Preferred genres</strong></Col></Row>
                        <Row className="mb-3">
                            <Col>
                                {venue.preferred_act_types.length > 0 && display_act_types}
                            </Col>
                        </Row>

                        <Row><Col><strong>Available slots</strong></Col></Row>
                        <Row className="mb-3">
                            <Col>
                                {venue.available_slots.length > 0 &&
                                    <span>
                                        {displaySlots}
                                    </span>
                                }
                            </Col>
                        </Row>

                        <Row><Col><strong>Electric outlets</strong></Col></Row>
                        <Row className="mb-3">
                            <Col>
                                <span dangerouslySetInnerHTML={{__html: electricOutletToText(venue.provide_electric)}}/>
                            </Col>
                        </Row>

                        <Row><Col><strong>Sound system</strong></Col></Row>
                        <Row className="mb-3">
                            <Col>
                                <span
                                    dangerouslySetInnerHTML={{__html: soundSystemToText(venue.provide_sound_system)}}/>
                            </Col>
                        </Row>

                        <Row><Col><strong>Rain date</strong></Col></Row>
                        <Row className="mb-3">
                            <Col>
                                {venue.rain_date_available &&
                                    <span>Available</span>
                                }
                                {!venue.rain_date_available &&
                                    <span>Unavailable</span>
                                }
                            </Col>
                        </Row>

                    </Container>
                </Card.Body>
            </Card>

            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Venue?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to delete "{venue.address}"?</p>
                    <p className="text-muted, small">
                        All acts scheduled at this venue will be unscheduled and their owners notified by email that this venue is no longer available.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={deleteVenue}>
                        Delete Venue
                    </Button>
                    <Button variant="outline-secondary" onClick={handleCloseDeleteModal}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    );
};

export default VenueItem;
